/* Kenneth Cutbush Shoulder Clinic — behaviour for the Webflow markup.
   Replaces the Webflow runtime: dropdown menus, accordions and the homepage slider. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------------------------------------------------- dropdowns -- */
  function dropdowns() {
    var items = [].slice.call(document.querySelectorAll('.w-dropdown'));
    if (!items.length) return;

    function close(d) {
      var t = d.querySelector('.w-dropdown-toggle'), l = d.querySelector('.w-dropdown-list');
      if (t) { t.classList.remove('w--open'); t.setAttribute('aria-expanded', 'false'); }
      if (l) l.classList.remove('w--open');
    }
    function open(d) {
      items.forEach(function (o) { if (o !== d) close(o); });
      var t = d.querySelector('.w-dropdown-toggle'), l = d.querySelector('.w-dropdown-list');
      if (t) { t.classList.add('w--open'); t.setAttribute('aria-expanded', 'true'); }
      if (l) l.classList.add('w--open');
    }
    function isOpen(d) {
      var l = d.querySelector('.w-dropdown-list');
      return !!l && l.classList.contains('w--open');
    }

    items.forEach(function (d) {
      var toggle = d.querySelector('.w-dropdown-toggle');
      if (!toggle) return;
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-expanded', 'false');

      if (d.getAttribute('data-hover') !== 'false') {
        d.addEventListener('mouseenter', function () { open(d); });
        d.addEventListener('mouseleave', function () { close(d); });
      }
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        isOpen(d) ? close(d) : open(d);
      });
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); isOpen(d) ? close(d) : open(d); }
      });
      d.addEventListener('focusin', function () { open(d); });
      d.addEventListener('focusout', function () {
        window.setTimeout(function () { if (!d.contains(document.activeElement)) close(d); }, 0);
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.w-dropdown')) items.forEach(close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') items.forEach(close);
    });
  }

  /* ---------------------------------------------------------- accordions -- */
  function accordions() {
    var triggers = [].slice.call(document.querySelectorAll(
      '.accordion-item-trigger, .accordion-item-trigger-2, .accordion-item-trigger-3,' +
      '.accordion-item-trigger-4, .accordion-item-trigger-5, .accordion-item-trigger-6'
    ));
    triggers.forEach(function (t, i) {
      var panel = t.nextElementSibling;
      while (panel && !panel.classList.contains('accordion-item-content')) {
        panel = panel.nextElementSibling;
      }
      if (!panel) return;

      if (!panel.id) panel.id = 'kc-acc-panel-' + i;
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      t.setAttribute('aria-expanded', 'false');
      t.setAttribute('aria-controls', panel.id);

      function toggle() {
        var open = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', open);
        t.classList.toggle('is-open', open);
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      t.addEventListener('click', toggle);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    if (window.location.hash) {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target) {
        var panel = target.closest('.accordion-item-content');
        if (panel) {
          panel.classList.add('is-open');
          var trig = panel.previousElementSibling;
          if (trig) { trig.classList.add('is-open'); trig.setAttribute('aria-expanded', 'true'); }
        }
        window.setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 50);
      }
    }
  }

  /* ------------------------------------------------------------- slider -- */
  function slider(root) {
    var slides = [].slice.call(root.querySelectorAll('.w-slide'));
    var nav = root.querySelector('.w-slider-nav');
    var prev = root.querySelector('.w-slider-arrow-left');
    var next = root.querySelector('.w-slider-arrow-right');
    if (slides.length < 2) {
      if (nav) nav.style.display = 'none';
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    var current = 0;
    var dots = [];
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 5000;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    slides.forEach(function (s, i) {
      s.style.transition = 'opacity 400ms ease';
      s.setAttribute('role', 'group');
      s.setAttribute('aria-roledescription', 'slide');
      s.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
    });

    if (nav) {
      nav.setAttribute('role', 'tablist');
      slides.forEach(function (s, i) {
        var dot = document.createElement('div');
        dot.className = 'w-slider-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('tabindex', '0');
        var label = s.querySelector('h1, h2, h3');
        dot.setAttribute('aria-label', label ? label.textContent.trim() : 'Slide ' + (i + 1));
        dot.addEventListener('click', function () { show(i); restart(); });
        dot.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(i); restart(); }
        });
        nav.appendChild(dot);
        dots.push(dot);
      });
    }

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === current;
        s.style.display = on ? 'inline-block' : 'none';
        s.style.opacity = on ? '1' : '0';
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('w-active', n === current);
        d.setAttribute('aria-selected', n === current ? 'true' : 'false');
      });
      var active = slides[current];
      active.style.opacity = '0';
      window.requestAnimationFrame(function () { active.style.opacity = '1'; });
    }

    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function restart() { stop(); if (autoplay && !reduce) timer = window.setInterval(function () { show(current + 1); }, delay); }

    if (prev) prev.addEventListener('click', function () { show(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(current + 1); restart(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', restart);
    document.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target.closest('.w-slide'));
      if (i > -1) { stop(); show(i); }
    });

    show(0);
    restart();
  }

  ready(function () {
    dropdowns();
    accordions();
    [].slice.call(document.querySelectorAll('.w-slider')).forEach(slider);
  });
})();
